import React from "react";
import { groupAdminSections } from "../../helpers/adminSectionAccess";
import "./desktopSidebar.css";

export function DesktopSidebar({
  sections,
  activeSectionId,
  onSelectSection,
  orgName,
  ariaLabel,
  leadItemId,
  returnLabel,
  onReturn,
}) {
  const groups = groupAdminSections(
    sections.filter((section) => section.id !== leadItemId),
  );
  const leadItem = leadItemId
    ? sections.find((section) => section.id === leadItemId)
    : null;

  return (
    <nav className="admin-sidebar" aria-label={ariaLabel}>
      {onReturn ? (
        <button type="button" className="admin-sidebar-return" onClick={onReturn}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m15 6-6 6 6 6" />
          </svg>
          <span>{returnLabel || "CrewPilot"}</span>
        </button>
      ) : null}
      <div className="admin-sidebar-org">
        {orgName || "Organization"}
      </div>

      {leadItem ? (
        <button
          type="button"
          className={`admin-sidebar-item${
            activeSectionId === leadItem.id ? " is-active" : ""
          }`}
          aria-current={activeSectionId === leadItem.id ? "page" : undefined}
          onClick={() => onSelectSection(leadItem.id)}
        >
          {leadItem.label}
        </button>
      ) : null}

      {Array.from(groups.entries()).map(([groupName, groupSections]) => (
        <div key={groupName || "ungrouped"} className="admin-sidebar-group">
          {groupName ? (
            <div className="admin-sidebar-group-label">{groupName}</div>
          ) : null}
          {groupSections.map((section) => {
            const className = `admin-sidebar-item${
              activeSectionId === section.id ? " is-active" : ""
            }`;
            const copy = (
              <>
                <span className="admin-sidebar-item-icon" aria-hidden="true">
                  {section.icon}
                </span>
                <span className="admin-sidebar-item-copy">
                  {section.kicker ? (
                    <span className="admin-sidebar-item-kicker">{section.kicker}</span>
                  ) : null}
                  {section.label}
                </span>
              </>
            );
            if (section.href) {
              return (
                <a key={section.id} href={section.href} className={className}>
                  {copy}
                </a>
              );
            }
            return (
              <button
                key={section.id}
                type="button"
                className={className}
                aria-current={activeSectionId === section.id ? "page" : undefined}
                onClick={() => onSelectSection(section.id)}
              >
                {copy}
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
